import { AbstractConnector } from '@web3-react/abstract-connector';
import Web3 from 'web3';
import { ConsolidationKeyInterface } from '../../../store/reducers/consolidate';
import { TransactionStatus } from '../../../store/actions/depositFileActions';
import { Dispatch } from 'react';
import { Action, ActionTypes } from '../../../store/actions';
import { isUserRejectionError } from '../../Transactions/transactionUtils';
import { generateCompoundParams } from '../utils';

export const eligibleForTx = (validators: ConsolidationKeyInterface[]) => {
  return validators.filter(
    key =>
      key.isSource &&
      (key.transactionStatus === TransactionStatus.READY ||
        key.transactionStatus === TransactionStatus.REJECTED)
  );
};

const handleMultipleConsolidations = async (
  web3: Web3,
  account: string,
  validators: ConsolidationKeyInterface[],
  targetValidator: string,
  dispatch: Dispatch<Action>
) => {
  const remainingValidators = eligibleForTx(validators);

  const nextSourceValidator = remainingValidators.shift();
  if (!nextSourceValidator) return;

  const { transactionParams } = await generateCompoundParams(
    web3,
    account,
    nextSourceValidator.pubkey,
    targetValidator
  );

  web3.eth
    .sendTransaction(transactionParams)
    .on('transactionHash', (txHash: string) => {
      dispatch({
        type: ActionTypes.updateTransactionStatus,
        payload: {
          pubkey: nextSourceValidator.pubkey,
          status: TransactionStatus.PENDING,
          txHash: txHash,
        },
      });
      handleMultipleConsolidations(
        web3,
        account,
        validators,
        targetValidator,
        dispatch
      );
    })
    .on(
      'confirmation',
      (confirmation: number, receipt: { status: {} }): any => {
        if (confirmation === 0) {
          if (receipt.status) {
            dispatch({
              type: ActionTypes.updateTransactionStatus,
              payload: {
                pubkey: nextSourceValidator.pubkey,
                status: TransactionStatus.SUCCEEDED,
              },
            });
          } else {
            dispatch({
              type: ActionTypes.updateTransactionStatus,
              payload: {
                pubkey: nextSourceValidator.pubkey,
                status: TransactionStatus.FAILED,
              },
            });
          }
        }
      }
    )
    .on('error', (error: any) => {
      if (isUserRejectionError(error)) {
        dispatch({
          type: ActionTypes.updateTransactionStatus,
          payload: {
            pubkey: nextSourceValidator.pubkey,
            status: TransactionStatus.REJECTED,
          },
        });
      } else {
        dispatch({
          type: ActionTypes.updateTransactionStatus,
          payload: {
            pubkey: nextSourceValidator.pubkey,
            status: TransactionStatus.FAILED,
          },
        });
      }
    });
};

export const sendConsolidationTransactions = async (
  account: any,
  connector: AbstractConnector | undefined,
  validators: ConsolidationKeyInterface[],
  dispatch: Dispatch<Action>
) => {
  if (!account) return;

  const targetValidators = validators.filter(val => val.isTarget);
  if (targetValidators.length !== 1) return;

  const targetValidator = targetValidators[0];

  const web3Provider: any = await (connector as AbstractConnector).getProvider();
  const web3 = new Web3(web3Provider);

  await handleMultipleConsolidations(
    web3,
    account,
    validators,
    targetValidator.pubkey,
    dispatch
  );
};
